import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const LockClosedSolid = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill="currentColor">
      <path
        d="M16.25 6.667c0-2.203-1.769-3.917-4.25-3.917S7.75 4.464 7.75 6.667v3.583h8.5zM17.75 11a.75.75 0 0 1-.75.75H7a.75.75 0 0 1-.75-.75V6.667c0-3.13 2.542-5.417 5.75-5.417s5.75 2.287 5.75 5.417z"
        vectorEffect="non-scaling-stroke"
      />
      <path
        fillRule="evenodd"
        d="M19 9.5a1.5 1.5 0 0 1 1.5 1.5v10a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 21V11A1.5 1.5 0 0 1 5 9.5zm-7 4a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5"
        clipRule="evenodd"
        vectorEffect="non-scaling-stroke"
      />
    </g>
  </svg>
);
const ForwardRef = forwardRef(LockClosedSolid) as SvgIcon;
export { ForwardRef as ReactComponent };
